<h1 mat-dialog-title class="title">
  Validação do Perfil
  <mat-icon color="accent" class="float-right" *ngIf="validation && validation.validated">verified_user</mat-icon>
</h1>
<div mat-mat-dialog-content class="validation-content">
  <ng-container *ngIf="validation">

    <form class="example-form">
      <div class="field-grid">

        <mat-form-field>
          <mat-label>Data</mat-label>
          <input readonly matInput [value]="validation.created_at | date: 'dd/MM/yyyy HH:mm'">
        </mat-form-field>

        <mat-form-field>
          <mat-label>Protocolo</mat-label>
          <input readonly matInput [value]="validation.uid">
        </mat-form-field>

        <mat-form-field>
          <mat-label>Validador</mat-label>
          <app-image-view class="input-image" matPrefix [src]="validation.behalf.photo_url" [imageSize]="36"
            radius="100%"></app-image-view>
          <input readonly matInput [value]="validation.behalf.name">
        </mat-form-field>
        <mat-form-field>
          <mat-label>Agente</mat-label>
          <input readonly matInput [value]="validation.user.name">
          <app-image-view matPrefix [src]="validation.user.photo_url" [imageSize]="36" radius="100%"></app-image-view>
        </mat-form-field>

        <mat-form-field *ngIf="validation.validation_expires">
          <mat-label>Validade</mat-label>
          <input readonly matInput [value]="validation.validation_expires | date: 'dd/MM/yyyy'">
        </mat-form-field>

      </div>

    </form>

    <div class="group" *ngIf="validation.documents && validation.documents.length >0">
      <div class="group-name">Documentos Validados</div>
      <div class="group-subtitle">Estes documentos não poderão ser alterados</div>
      <div class="group-body group-documents field-grid">

        <mat-card class="document mat-elevation-z4" *ngFor="let document of validation.documents">
          <div class="name">
            {{document.document_type.name}}
          </div>
          <div class="date">
            {{document.created_at | date:'dd/MM/yyyy HH:mm'}}
          </div>
        </mat-card>
      </div>
    </div>

    <div class="group" *ngIf="validation.rejections && validation.rejections.length >0">
      <div class="group-name">Rejeições</div>
      <div class="group-subtitle" *ngIf="documentsRejecteds.length >0" >Os documentos rejeitados foram excluidos.</div>
      <div class="group-body group-documents field-grid">

        <mat-card class="document mat-elevation-z4" *ngFor="let rejection of validation.rejections"
          (click)="rejectionClick(rejection)">
          <div class="name">{{rejection.typeName}}</div>
          <div class="date">
            {{rejection.reason}}
          </div>
        </mat-card>
      </div>
    </div>

    <div class="group" *ngIf="validation.message">
      <div class="group-name">Observações</div>
      <div class="group-subtitle">Mensagem do agente validador.</div>
      <div class="group-body group-documents field-grid">
        <div class="message">{{validation.message}}</div>
      </div>
    </div>


  </ng-container>

  <ng-container *ngIf="!validation">
    Carregando validação..
  </ng-container>
</div>

<div class="actions" mat-dialog-actions>
  <button mat-raised-button (click)="close()">
    Fechar
  </button>
</div>
